import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import Footer from "../pallet/Footer";

const styles = {
  button: {
    minWidth: 100,
  },
};

export default function Step1({ total, onBack, onNext, onMoveAll }) {
  return (
    <>
      <DialogContent>
        <Box textAlign="center" mb={3} minHeight={300} display="flex" alignItems="center">
          <Box width="100%">
            <Typography color="textPrimary" mb={4}>
              Are you moving the entire quantity of {total}?
            </Typography>
            <Box display="flex" justifyContent="center" gap={1}>
              <Button variant="outlined" onClick={() => onNext()} sx={styles.button}>
                No
              </Button>
              <Button variant="outlined" onClick={onMoveAll} sx={styles.button}>
                Yes
              </Button>
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <Footer step={0}>
        <Box />
        <Box display="flex" gap={1}>
          <Button variant="outlined" onClick={onBack} sx={styles.button}>
            Back
          </Button>
          <Button variant="contained" color="primary" disabled={true} sx={styles.button}>
            Next
          </Button>
        </Box>
      </Footer>
    </>
  );
}
